import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganisationService } from 'src/services/organisation.service';
import { OrganisationModel } from 'src/models/pilotage/organisationModel';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-edit-parametres-organisation-dialog',
    imports: [MatProgressSpinnerModule, FormsModule, TranslateModule],
    templateUrl: './edit-parametres-organisation-dialog.component.html',
    styleUrl: './edit-parametres-organisation-dialog.component.scss'
})
export class EditParametresOrganisationDialogComponent implements OnInit {
  organisation?: OrganisationModel;
  isLoading = true;
  isSaving = false;
  aUtilisateursFictifs = false;
  aAccesDiffusion = false;
  aAccesIndex = false;
  aTenantSSO = false;

  constructor(
    private dialogRef: MatDialogRef<EditParametresOrganisationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { entiteId: number },
    private organisationService: OrganisationService
  ) {}

  ngOnInit(): void {
    this.organisationService.obtenirOrganisation(this.data.entiteId).subscribe(org => {
      this.organisation = org;
      this.aUtilisateursFictifs = org.aUtilisateursFictifs;
      this.aAccesDiffusion = org.aAccesDiffusion;
      this.aAccesIndex = org.aAccesIndex;
      this.aTenantSSO = org.aTenantSSO;
      this.isLoading = false;
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (!this.organisation) return;
    this.isSaving = true;
    this.organisationService.majParametresEntite(this.organisation.entiteId, this.aUtilisateursFictifs, this.aAccesDiffusion, this.aAccesIndex, this.aTenantSSO)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.dialogRef.close(true);
        },
        error: () => {
          this.isSaving = false;
        }
      });
  }
}
